<template>
  <div class="main-layout main-layout_fullpage">
    <div class="main-layout__controls">
      <tab-tags :active="active" @changeView="changeView" />
    </div>

    <component :is="active" />
  </div>
</template>

<script>
import tabTags from '@/components/controls/tabTags'
import works from '@/views/tags/index'
import skills from '@/views/tags/skills'
import tools from '@/views/tags/tools'
import { mapActions, mapMutations } from 'vuex'

export default {
    components: {
        tabTags, works, skills, tools,
    },
    data() {
        return {
            active: 'works',
        }
    },
    methods: {
        ...mapActions({
            fetchSkills: 'skills/fetch',
            fetchTools: 'tools/fetch',
            fetchTags: 'tags/fetch',
        }),
        ...mapMutations({
            setLink: 'setLink',
        }),
        changeView(v) {
            this.active = v
        },
    },
    async created() {
        await this.fetchTags()
        await this.fetchSkills()
        await this.fetchTools()
    },
    mounted() {
        this.setLink({
            key: 'infoRootLink',
            value: 'https://doc.clickup.com/p/h/4hhzv-2261/b3680a8a1854f72/4hhzv-2261',
        })
        this.setLink({
            key: 'infoLink',
            value: 'https://doc.clickup.com/p/h/4hhzv-1461/fab043ebadc501e',
        })
    },
    beforeDestroy() {
        this.setLink({
            key: 'infoRootLink',
            value: null,
        })
        this.setLink({
            key: 'infoLink',
            value: null,
        })
    },
}
</script>
